import { User } from 'oidc-client-ts';
import { config } from '../components/Authentification/config';
import { getXPToken } from '../components/Layout/Promotions/services';
import { AxiosError } from 'axios';

export function getUser(): User | undefined {
  const key = `oidc.user:${config.authUrl}/realms/${config.realm}:${config.clientId}`;

  try {
    const oidcStorage = localStorage.getItem(key) ?? sessionStorage.getItem(key);

    if (!oidcStorage) {
      return;
    }

    return User.fromStorageString(oidcStorage);
  } catch {
    return;
  }
}

export function getToken(): string {
  const user = getUser();

  return user?.access_token ?? user?.access_token ?? '';
}

export const isXPTokenExpired = (token: string): boolean => {
  if (!token) return true;

  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const { exp } = JSON.parse(atob(base64)) as { exp: number };

    return exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

export const getActualXPToken = async (token: string, setToken: (arg: string) => void): Promise<string> => {
  let activeToken;

  if (isXPTokenExpired(token)) {
    try {
      activeToken = await getXPToken();
      setToken(activeToken);
    } catch (error) {
      const status = (error as AxiosError)?.response?.status;

      if (status === 401) {
        activeToken = await getXPToken();
      }
    }
  }

  return activeToken || token;
};
